<template>
    <div class="staffMagList">
        <div class="filters">
            <div class="add">
                <el-button type="primary" @click="addSubAccount">添加子账号</el-button>
            </div>
            <div class="search">
                <el-select v-model="param.roleinnerid" placeholder="全部角色" class="condition" clearable>
                    <el-option v-for="item in rankList" :key="item.innerid" :label="item.rolename" :value="item.innerid"> </el-option>
                </el-select>
                <el-select v-model="param.status" placeholder="全部状态" class="condition" clearable>
                    <el-option v-for="item in stateList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                </el-select>
                <el-input v-model.trim="param.username" placeholder="请输入商品名称" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <el-table :data="staffMagListData" style="width: 100%">
            <el-table-column prop="customerloginname" label="账号" class-name="tableItemOne"></el-table-column>
            <el-table-column prop="username" label="姓名" class-name="tableItem"></el-table-column>
            <el-table-column prop="rolename" label="角色" class-name="tableItem"></el-table-column>
            <el-table-column prop="operatorname" label="添加人" class-name="tableItem"></el-table-column>
            <el-table-column prop="datetime" label="添加时间" class-name="tableItem"></el-table-column>
            <el-table-column prop="state" label="状态" class-name="tableItem">
                <template slot-scope="scope">
                    <span :class="{'blockUpEd':scope.row.status == 0}">{{ scope.row.statusText }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="rank" label="操作" class-name="actionBox">
                <template slot-scope="scope">
                    <div class="action" v-if="atPresent">
                        <span class="blockUp" @click="action(scope.row, 1)" v-if="scope.row.status == 0">启用</span>
                        <span class="blockUp" @click="action(scope.row, 0)" v-if="scope.row.status == 1">停用</span>
                        |
                        <span class="redact" @click="handleEdit(scope.row)">编辑</span>
                        |
                        <span class="delete" @click="action(scope.row, 100)">删除</span>
                    </div>
                    <div v-else>当前账号</div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import {editChildAccountStauts, getChildAccountList, getRoleList} from '@/api/subAccountApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'staffMagList',
    data() {
        return {
            activeName: '员工管理',
            rankList: [],
            stateList: [
                {code: '', name: '全部状态'},
                {code: 1, name: '已启用'},
                {code: 0, name: '停用'}
            ],
            staffMagListData: [],
            atPresent: true,
            param: {
                roleinnerid: '',
                status: '',
                username: ''
            }
        }
    },
    mounted() {
        this._getRoleList()
        this._getChildAccountList()
    },
    methods: {
        handleQuery() {
            this._getChildAccountList()
        },
        handleEdit(row) {
            this.$router.push({name: 'SubAccountAdd', query: {id: row.innerid}})
        },
        addSubAccount() {
            if (this.rankList.length) {
                this.$router.push({name: 'SubAccountAdd'})
            } else {
                this.$alert('请新建角色！', '提示', {
                    dangerouslyUseHTMLString: true
                })
            }
        },
        action(row, status) { // 状态(0停用 1启用 100删除)
            let tip = ''
            switch (status) {
            case 0: tip = '停用'
                break
            case 1: tip = '启用'
                break
            case 100: tip = '删除'
                break
            }
            this.$confirm(`确定${tip}该角色？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                editChildAccountStauts({
                    data: {
                        innerid: row.innerid,
                        status: status
                    },
                    success: data => {
                        this.setLoading(false)
                        this.$message.success(`${tip}成功！`)
                        this._getRoleList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        _getRoleList() {
            this.setLoading(true)
            getRoleList({
                data: {page: '1', pageSize: '10'},
                success: data => {
                    this.rankList = data.data.content
                    let obj = {
                        datetime: '',
                        innerid: '',
                        memo: '',
                        rolename: '全部角色',
                        status: ''
                    }
                    this.rankList.unshift(obj)
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getChildAccountList() {
            this.setLoading(true)
            getChildAccountList({
                data: Object.assign({}, this.param, {page: '1', pageSize: '10'}),
                success: data => {
                    this.staffMagListData = data.data.content
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'page',
            'user'
        ])
    }
}
</script>
<style lang="scss">
    .staffMagList{
        .height-36{
                height: 36px;
        }
        .el-row{
            .el-col{
                height: 36px;
            }
        }
        .actionRight{
            display: flex;
            justify-content: flex-end;
            .inputBox{
                height: 36px;
                .el-input{
                    .el-input__inner{
                        width: 240px;
                        height: 36px;
                        box-sizing: border-box;
                    }
                }
            }
            .el-dropdown,.inputBox,.searchBtnBox{
                margin-right: 20px;
            }
        }
        .el-table{
            margin-top: 30px;
            .tableItemOne{
            padding-left: 10px;
            }
            .tableItem{
                text-align: center;
            }
            .actionBox{
                text-align: right;
                padding-right: 10px;
            }
            .action{
                color: #409EFF;
                text-align: right;
                span{
                    position: relative;
                    top: 1px;
                    cursor: pointer;
                }
            }
            .blockUpEd{
                color: #F56C6C;
            }
        }
    }
</style>
